/**
* PCC 500 keyword universe — sourced from the user-supplied 2026 PCC
* keyword doc. Every keyword is surfaced somewhere in the /pcc/* cluster
* (services, cities, destinations, intents, documents, embassies,
* questions hub, Q&A JSONL feed).
*/

export const PCC_500_KEYWORDS = {
  core: [
    "ขอใบรับรองความประพฤติ", "ใบตรวจประวัติอาชญากรรม", "ตรวจประวัติอาชญากรรม",
    "ขอประวัติอาชญากรรม", "ใบแจ้งความประพฤติ", "ขอประวัติอาชญากรรม สำนักงานตำรวจแห่งชาติ",
    "ขอประวัติอาชญากรรม ออนไลน์", "ตรวจประวัติอาชญากรรม ออนไลน์",
    "ใบรับรองประวัติอาชญากรรม", "รับทำใบรับรองความประพฤติ",
    "บริการใบตรวจประวัติอาชญากรรม", "เอเจนซี่ขอใบรับรองความประพฤติ",
    "รับทำ police clearance", "police clearance certificate thailand",
    "police clearance thailand", "thai police clearance", "thai police check",
    "criminal record check thailand", "police certificate thailand",
    "background check thailand", "thailand criminal background check",
    "ขอใบตรวจ", "ขอใบประวัติอาชญากรรม", "ขอหนังสือรับรองความประพฤติ",
    "ตัวแทนตรวจสอบประวัติอาชญากรรม", "กองทะเบียนประวัติอาชญากร",
    "ตรวจสอบประวัติอาชญากรรมด้วยตนเอง", "ขอใบรับรองความประพฤติด่วน",
    "ขอใบประวัติอาชญากรรมด่วน", "urgent police clearance thailand",
    "ขอใบรับรองความประพฤติราคา", "ตรวจประวัติอาชญากรรมค่าใช้จ่าย",
    "ขอใบรับรองความประพฤติไปต่างประเทศ", "criminal record certificate thailand",
    "thai certificate of good conduct", "certificate of good conduct thailand",
    "หนังสือรับรองความประพฤติภาษาอังกฤษ", "ใบตรวจประวัติอาชญากรรมภาษาอังกฤษ",
    "แปลใบประวัติอาชญากรรม", "รับรองใบรับรองความประพฤติ",
    "police clearance with apostille thailand",
  ],
  visas: [
    "ใบประวัติอาชญากรรมยื่นวีซ่าอเมริกา", "ใบประวัติอาชญากรรมยื่นวีซ่าอังกฤษ",
    "ใบประวัติอาชญากรรมยื่นวีซ่าออสเตรเลีย", "ใบประวัติอาชญากรรมยื่นวีซ่าแคนาดา",
    "ใบประวัติอาชญากรรมยื่นวีซ่านิวซีแลนด์", "ใบประวัติอาชญากรรมยื่นวีซ่าเชงเก้น",
    "ใบประวัติอาชญากรรมไปเกาหลี", "ใบประวัติอาชญากรรมไปญี่ปุ่น",
    "ใบประวัติอาชญากรรมไปสิงคโปร์", "ใบประวัติอาชญากรรมไปดูไบ",
    "ขอใบรับรองความประพฤติ pr", "ขอใบรับรองความประพฤติสัญชาติ",
    "ขอใบรับรองความประพฤติ citizenship", "ขอใบรับรองความประพฤติวีซ่าคู่รัก",
    "ขอใบรับรองความประพฤติวีซ่าคู่สมรส", "ขอใบรับรองความประพฤติวีซ่านักเรียน",
    "ขอใบรับรองความประพฤติวีซ่าทำงาน", "police clearance for australian visa",
    "police clearance thailand for us visa", "police clearance thailand for uk visa",
    "police clearance for canada visa", "police clearance for schengen visa",
    "police clearance for new zealand visa", "police clearance for south korea visa",
    "police clearance for japan visa", "police clearance for green card",
    "police clearance for permanent residence", "thai pcc for immigration",
    "thai police clearance for employment", "thai pcc for study abroad",
    "police clearance thailand for adoption", "pcc for marriage abroad",
  ],
  overseas: [
    "ขอใบรับรองความประพฤติจากต่างประเทศ", "ขอประวัติอาชญากรรมคนไทยในต่างประเทศ",
    "มอบอำนาจขอใบรับรองความประพฤติ", "มอบอำนาจตรวจประวัติอาชญากรรม",
    "police clearance thailand from abroad", "police clearance thailand overseas",
    "applying for thai police clearance from overseas",
    "ขอใบรับรองความประพฤติชาวต่างชาติ", "ขอประวัติอาชญากรรมชาวต่างชาติ",
    "police clearance thailand for foreigners", "criminal record check for foreigners thailand",
    "thai police clearance for non thai citizens",
    "ขอใบรับรองความประพฤติต่างชาติเคยอยู่ไทย", "police clearance thailand former expat",
    "police check thailand for expats", "thai pcc from usa", "thai pcc from uk",
    "thai pcc from australia", "thai pcc from canada", "thai pcc from germany",
    "thai pcc from singapore", "thai pcc from japan", "thai pcc from korea",
    "power of attorney thai police clearance", "poa police clearance thailand",
  ],
  documents: [
    "ขอใบรับรองความประพฤติใช้เอกสารอะไรบ้าง", "ตรวจประวัติอาชญากรรมใช้เอกสารอะไรบ้าง",
    "documents for thai police clearance", "แบบฟอร์มขอใบรับรองความประพฤติ",
    "พิมพ์ลายนิ้วมือขอประวัติอาชญากรรม", "พิมพ์ลายนิ้วมือสำนักงานตำรวจแห่งชาติ",
    "fingerprint police clearance thailand", "fingerprint card for thai police clearance",
    "ใบพิมพ์ลายนิ้วมือต่างประเทศ", "fingerprint card fbi fd-258 thailand",
    "fd-258 fingerprint thailand", "รูปถ่ายขอประวัติอาชญากรรม",
    "photos required for thai police clearance", "หนังสือมอบอำนาจ police clearance",
    "หนังสือแจ้งความจำนงต่างประเทศ", "request letter for thai police clearance",
    "company request letter for police check",
    "ดาวน์โหลดแบบฟอร์มขอใบรับรองความประพฤติ",
    "download fingerprint form fd-258", "police clearance thailand form download",
  ],
  cities: [
    "ขอใบรับรองความประพฤติกรุงเทพ", "ขอใบรับรองความประพฤติปทุมวัน",
    "ขอประวัติอาชญากรรมสำนักงานตำรวจแห่งชาติปทุมวัน",
    "police clearance center bangkok", "special branch police thailand clearance",
    "ขอใบตรวจสวนพลู", "องค์กรบริการขอสัญชาติสำนักงานตำรวจแห่งชาติ",
    "ขอใบรับรองความประพฤติเชียงใหม่", "ขอใบตรวจขอนแก่น",
    "ขอใบตรวจอุดรธานี", "ขอใบตรวจภูเก็ต", "ขอใบตรวจพัทยา",
    "ขอใบตรวจนครราชสีมา", "ขอใบตรวจหาดใหญ่", "ขอใบตรวจสงขลา",
    "ขอใบตรวจสุราษฎร์ธานี", "ขอใบตรวจนครปฐม", "ขอใบตรวจสมุทรปราการ",
    "ขอใบตรวจนนทบุรี", "ขอใบตรวจปทุมธานี", "ขอใบตรวจอยุธยา",
    "police clearance agency bangkok", "police clearance service thailand",
    "get thai police clearance from khon kaen", "get thai police clearance from udon thani",
    "get thai police clearance from chiang mai", "get thai police clearance from phuket",
    "get thai police clearance from pattaya",
  ],
  professions: [
    "ใบตรวจประวัติอาชญากรรมครูต่างประเทศ", "ตรวจประวัติอาชญากรรมครูต่างประเทศ",
    "ขอใบรับรองความประพฤติเรียนต่อต่างประเทศ", "police clearance thailand employment",
    "ขอใบรับรองความประพฤติแรงงานต่างประเทศ", "criminal background check for teachers thailand",
    "police check for pilots thailand", "police check for airline crew thailand",
    "police check for security guards thailand", "employee background verification thailand",
    "ตรวจประวัติอาชญากรรมสมัครงานต่างประเทศกรมแรงงาน",
    "thai police clearance ministry of labour",
  ],
  express: [
    "ขอใบรับรองความประพฤติด่วน 1 วัน", "ขอใบตรวจประวัติอาชญากรรม same day",
    "urgent thai police clearance 24 hours", "fast track police clearance thailand",
    "same day police clearance bangkok", "express police clearance thailand 5 days",
    "priority queue police clearance", "rush police clearance certificate thailand",
    "ตรวจประวัติอาชญากรรม 5-7 วัน", "ตรวจประวัติอาชญากรรม 24 ชั่วโมง",
    "ตรวจประวัติอาชญากรรมรับเช้าเสร็จเย็น",
  ],
  translation: [
    "แปลใบตรวจประวัติอาชญากรรม", "แปลใบรับรองความประพฤติ",
    "แปลรับรองประวัติอาชญากรรม NAATI", "แปล pcc รับรองสถานทูต",
    "translation police clearance thailand", "certified translation pcc thailand",
    "MFA legalization police clearance", "รับรองกระทรวงการต่างประเทศ pcc",
    "apostille police clearance thailand", "ประทับตราสถานทูต pcc",
    "consular legalization pcc", "embassy attestation thai pcc",
  ],
  process: [
    "ธรรมเนียมขอใบรับรองความประพฤติ", "ค่าธรรมเนียมประวัติอาชญากรรม",
    "thai police clearance cost", "police clearance thailand fee",
    "ขอใบรับรองความประพฤติใช้เวลากี่วัน", "thai police clearance processing time",
    "ขอประวัติอาชญากรรมทางไปรษณีย์", "police clearance thailand by mail",
    "จองคิว pcc ออนไลน์", "online booking pcc thailand",
    "walk-in police clearance bangkok", "pcc renewal thailand",
    "pcc expiry thailand", "pcc valid period thailand",
    "reissue lost police clearance thailand",
  ],
  longtail: [
    "ขอใบรับรองความประพฤตินักเรียนแลกเปลี่ยน",
    "ขอใบรับรองความประพฤติแม่บ้านต่างประเทศ",
    "ขอใบรับรองความประพฤติทำงานเรือสำราญ",
    "ขอใบรับรองความประพฤติอาสาสมัคร",
    "ขอใบรับรองความประพฤติทำงานอิสราเอล",
    "ขอใบรับรองความประพฤติทำงานญี่ปุ่น IM Japan",
    "ขอใบรับรองความประพฤติทำงานเกาหลี EPS",
    "ขอใบรับรองความประพฤติทำงานไต้หวัน",
    "ขอใบรับรองความประพฤติกรมการจัดหางาน",
    "ขอใบรับรองความประพฤติสมัคร USCG merchant mariner",
    "thai police clearance apostille service",
    "police clearance thailand hague apostille 2026",
    "ขอใบรับรองความประพฤติผู้เยาว์", "ขอใบรับรองความประพฤติเด็ก",
    "ขอใบรับรองความประพฤติผู้สูงอายุ", "ขอใบรับรองความประพฤติผู้ป่วยติดเตียง",
    "mobile fingerprinting pcc bangkok", "on-site fingerprinting police clearance",
    "pcc for adoption abroad", "pcc for surrogacy",
    "pcc for volunteer abroad", "pcc for missionary work",
    "pcc for un mission", "pcc for peace corps",
  ],
} as const;

// ── Intent buckets (drives /pcc/intent/$intent) ──────────────────────────
export const PCC_INTENTS = [
  { slug: "urgent", label: "PCC ด่วน / Same-Day", nameEn: "Urgent same-day PCC" },
  { slug: "express-5-7", label: "PCC Express 5-7 วัน", nameEn: "Express PCC 5-7 days" },
  { slug: "overseas-poa", label: "ขอ PCC จากต่างประเทศ (POA)", nameEn: "Overseas via POA" },
  { slug: "foreigner-in-thailand", label: "PCC สำหรับต่างชาติในไทย", nameEn: "Foreigner in Thailand" },
  { slug: "affordable", label: "PCC ราคาประหยัด", nameEn: "Affordable PCC" },
  { slug: "with-apostille", label: "PCC + Apostille / MFA", nameEn: "PCC with Apostille" },
  { slug: "with-translation", label: "PCC + แปลรับรอง", nameEn: "PCC with certified translation" },
  { slug: "corporate-bulk", label: "PCC บริษัท / Bulk", nameEn: "Corporate bulk PCC" },
  { slug: "for-employment", label: "PCC สมัครงาน / ทำงานต่างประเทศ", nameEn: "For employment abroad" },
  { slug: "for-immigration", label: "PCC ยื่นวีซ่า / ย้ายประเทศ", nameEn: "For immigration / PR" },
  { slug: "for-student", label: "PCC เรียนต่อต่างประเทศ", nameEn: "For student visa" },
  { slug: "for-marriage", label: "PCC วีซ่าคู่สมรส", nameEn: "For marriage / spouse visa" },
] as const;

// ── Document types (drives /pcc/documents/$doc) ──────────────────────────
export const PCC_DOCUMENT_TYPES = [
  { slug: "type-1", nameTh: "PCC Type 1 (Name-based)", nameEn: "Name-based check" },
  { slug: "type-2", nameTh: "PCC Type 2 (Fingerprint-based)", nameEn: "Fingerprint-based check" },
  { slug: "fd-258", nameTh: "FBI FD-258 Fingerprint Card", nameEn: "FBI FD-258 fingerprint card" },
  { slug: "no-conviction", nameTh: "No-Conviction Letter", nameEn: "No conviction letter" },
  { slug: "bilingual", nameTh: "PCC 2 ภาษา (Thai + English)", nameEn: "Bilingual Thai/English" },
  { slug: "certified-copy", nameTh: "สำเนารับรอง PCC", nameEn: "Certified duplicate copy" },
  { slug: "translation", nameTh: "PCC แปลรับรอง", nameEn: "Certified translation" },
  { slug: "apostille", nameTh: "PCC + Hague Apostille", nameEn: "PCC with Hague Apostille" },
  { slug: "mfa-legalization", nameTh: "PCC + รับรอง MFA", nameEn: "PCC with MFA legalization" },
  { slug: "embassy-attestation", nameTh: "PCC + ประทับตราสถานทูต", nameEn: "PCC with embassy attestation" },
] as const;

// ── Embassy targets (drives /pcc/embassy/$slug) ──────────────────────────
export const PCC_EMBASSY_TARGETS = [
  { slug: "us-embassy", nameTh: "สถานทูตสหรัฐฯ Bangkok", nameEn: "US Embassy Bangkok" },
  { slug: "uk-embassy", nameTh: "สถานทูตสหราชอาณาจักร", nameEn: "UK Embassy Bangkok" },
  { slug: "au-embassy", nameTh: "สถานทูตออสเตรเลีย", nameEn: "Australian Embassy Bangkok" },
  { slug: "ca-embassy", nameTh: "สถานทูตแคนาดา", nameEn: "Canadian Embassy Bangkok" },
  { slug: "nz-embassy", nameTh: "สถานทูตนิวซีแลนด์", nameEn: "New Zealand Embassy Bangkok" },
  { slug: "jp-embassy", nameTh: "สถานทูตญี่ปุ่น", nameEn: "Embassy of Japan Bangkok" },
  { slug: "kr-embassy", nameTh: "สถานทูตเกาหลีใต้", nameEn: "Embassy of Korea Bangkok" },
  { slug: "de-embassy", nameTh: "สถานทูตเยอรมนี", nameEn: "German Embassy Bangkok" },
  { slug: "fr-embassy", nameTh: "สถานทูตฝรั่งเศส", nameEn: "French Embassy Bangkok" },
  { slug: "sg-embassy", nameTh: "สถานทูตสิงคโปร์", nameEn: "Singapore Embassy Bangkok" },
] as const;
